import { useCreateQueryKeys as e } from "@maat/store-hooks";
//#region src/phoneAuth/admin/phoneAuthAdminQueryKeys.ts
var t = e("admin-phone-auth", {
	stats: (e) => ["stats", e],
	health: () => ["health"],
	transactions: (e) => e === void 0 ? ["transactions"] : ["transactions", e],
	transaction: (e) => ["transaction", e]
});
//#endregion
export { t as phoneAuthAdminQueryKeys };
